import type { Book } from '../types/sales'

export const books: Book[] = [
  {
    id: 'seduccion',
    volume: 1,
    title: 'Seducción Sin Máscaras',
    promise:
      'La guía práctica para atraer de verdad — sin juegos, sin fingir, sin técnicas ridículas',
    intro:
      'La seducción real no se trata de trucos. Se trata de entender cómo funciona la atracción y aplicarlo desde quien realmente eres. Este libro te da el sistema completo.',
    bullets: [
      'Los 5 mitos de la seducción que te han saboteado toda la vida (y cómo eliminarlos hoy)',
      'Cómo usar el lenguaje corporal para atraer sin decir una sola palabra',
      'Conversaciones que generan química real en los primeros 5 minutos',
      'Cómo crear primeras impresiones memorables que hacen que te recuerden días después',
      'El plan de 30 días para dominar la atracción desde cero'
    ],
    value: '$27',
    cover:
      'https://cdn.magicpatterns.com/uploads/kMWQvL8BH6FyYN3EjPDBiv/Seduccion_Sin_Mascaras.png',
    glyph: '📕'
  },
  {
    id: 'historias',
    volume: 2,
    title: '30 Historias de Amor Verdadero',
    promise:
      'Las lecciones que nadie te contó — contadas por personas reales que las vivieron',
    intro:
      'Cada historia está escrita para que te metas en ella. Y al final de cada una, una lección concreta que puedes aplicar en tu vida hoy. No es ficción romántica. Es un manual disfrazado de historias.',
    bullets: [
      '30 historias reales con lecciones de vida que no te van a dar en ningún otro lado',
      'Cómo identificar el amor genuino vs. el amor que solo cubre un vacío',
      'Los patrones que aparecen en todas las historias de amor que funcionan',
      'Por qué algunas personas siguen repitiendo los mismos errores en sus relaciones',
      'Lecciones que se quedan contigo porque las sentiste, no solo las leíste'
    ],
    value: '$27',
    cover:
      'https://cdn.magicpatterns.com/uploads/bxojGVi7xhnFGTKFzumrok/30_Historias_de_Amor_Verdadero.png',
    glyph: '📗'
  },
  {
    id: 'citas',
    volume: 3,
    title: 'Guía de Primeras Citas que Funcionan',
    promise:
      'De nervios a conexión en una sola noche — sin ensayar, sin adivinar, sin arruinarla',
    intro:
      'Las primeras citas no se arruinan por mala suerte. Se arruinan por no saber exactamente qué hacer. Este libro te da el mapa completo para ir con confianza total.',
    bullets: [
      'Qué decir, qué preguntar y qué JAMÁS hacer en una primera cita',
      'Cómo crear tensión y química de manera natural (sin que se sienta forzado)',
      'Los errores más comunes que matan la atracción antes de que empiece',
      'Cómo terminar la cita de manera que quieran una segunda sin que tengas que pedirla',
      'El checklist de pre-cita que elimina el 90% de los nervios'
    ],
    value: '$27',
    cover:
      'https://cdn.magicpatterns.com/uploads/aqbkhJdUrxN1SqxjmKPrq2/Guia_de_Primeras_Citas_que_Funcionan.png',
    glyph: '📘'
  },
  {
    id: 'palabras',
    volume: 4,
    title: 'Más Allá de las Palabras',
    promise:
      'Cómo leer el lenguaje corporal y saber exactamente si hay atracción real o solo cortesía',
    intro:
      'El 93% de la comunicación no es lo que dices. Es cómo lo dices, cómo te mueves, cómo los miras. Este libro te enseña a leer ese lenguaje que todos hablan pero nadie entiende.',
    bullets: [
      'Las 12 señales de atracción que la mayoría ignora completamente',
      'Cómo saber si alguien está interesado en ti en los primeros 3 minutos',
      'Los gestos de desinterés que te ahorran tiempo (y dignidad)',
      'Cómo mejorar tu propio lenguaje corporal para parecer más magnético y seguro',
      'Micro-expresiones: la verdad que el rostro revela aunque la boca calle'
    ],
    value: '$27',
    cover:
      'https://cdn.magicpatterns.com/uploads/5TPLr4qf4k2r3bT9d64PWi/Mas_Alla_de_las_Palabras.png',
    glyph: '📙'
  },
  {
    id: 'conversacion',
    volume: 5,
    title: 'El Arte de la Conversación',
    promise:
      'De extraños a conexión real — las preguntas y temas que generan química verdadera',
    intro:
      'Una conversación mediocre arruina incluso la mejor primera impresión. Una conversación extraordinaria convierte a un extraño en alguien que quiere verte de nuevo. Este libro marca esa diferencia.',
    bullets: [
      'Las preguntas exactas que generan conversaciones profundas y memorables',
      'Cómo pasar de la charla superficial a la conexión genuina en menos de 10 minutos',
      'Técnicas de escucha activa que hacen que la otra persona se sienta completamente vista',
      'Los temas que crean química y los que la matan al instante',
      'Cómo terminar una conversación de manera que quieran continuarla'
    ],
    value: '$27',
    cover:
      'https://cdn.magicpatterns.com/uploads/wL6yQdJ4v778teUjNSd34j/El_Arte_de_la_Conversacion_De_Extranos_a_Conexion_Real.png',
    glyph: '📓'
  }
]
